module.exports = __webpack_public_path__ + "static/media/slide_2.5b83ad8f.webp";